import { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useAppDispatch } from '../redux/store';
import {
  postLoungeCommentReply,
  postLoungeCommentEdit,
  postLoungeCommentEditWdw,
  fetchLoungeDetails,
  fetchStickerLounges,
  addSticker,
} from '../redux/lounges/slice';
import stickerImage from '../assets/img/stickers.jpg';
import { StickerTabs } from '../components/StickerTabs';
import { selectLounges } from '../redux/lounges/selectors';

import { ReactQuill } from './LazyEditors';
import 'react-quill/dist/quill.snow.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { removeUserLounge } from '../redux/lounges/slice';

import axios, { AxiosResponse } from 'axios';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { GET_BASE_URL_IMAGE } from '../constants/apiEndpoints';
import { insertCommentMention } from '../utils/commentMentionInsert';

type EditBoxPropsType = {
  replyData: any;

  chatId: any;
  chat_reply_id: any;
  stickerData: any;
  id: any;
  editbox: boolean;
  type: string;
  chat_reply_msg: string;
};
type FormData = {
  chat_reply_msg: string;
  chat_id: number;
  chat_reply_id: number;
  type: string;
  id: number;
};

export const EditBox: React.FC<EditBoxPropsType> = ({
  replyData,

  chatId,
  chat_reply_id,
  stickerData,
  editbox,
  type,
  chat_reply_msg,
  id,
}) => {
  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();
  const dispatch = useAppDispatch();
  const selectedMentionRef = useRef('');

  const mentions = useMemo(
    () => ({
      allowedChars: /^[A-Za-z0-9_\-\sÅÄÖåäö]*$/,
      mentionDenotationChars: ['@'],
      source: (
        searchTerm: any,
        renderList: any,
        mentionChar: any,
        _callback: any
      ) => {
        setSearchText(searchTerm);
        // console.log('searchTerm', searchTerm)
        const normalizedSearchTerm = String(searchTerm ?? '').toLowerCase();

        if (
          selectedMentionRef.current &&
          normalizedSearchTerm === selectedMentionRef.current
        ) {
          selectedMentionRef.current = '';
          setFilterUser([]);
          renderList([]);
          return;
        }

        if (mentionChar !== '@' || searchTerm.length === 0) {
          setFilterUser([]);
          renderList([]);
        } else {
          axios
            .get(GET_BASE_URL + '/api/v1/getUser?name=' + searchTerm)
            .then((response: any) => {
              const includesSearchTerm = response.data.data.filter(
                (item: any) =>
                  item.value.toLowerCase().includes(searchTerm.toLowerCase())
              );

              setFilterUser(includesSearchTerm);
              renderList([]);
            });

        }
      },
    }),
    []
  );

  const modules = {
    mention: mentions,
    toolbar: false,
  };
  //const [commentData, SetCommentData] = useState<any | []>(replyData);
  const [showSticker, SetShowSticker] = useState<any | string>(false);
  const [stickerSelection, SetStickerSelection] = useState<string>('');
  //const [edittype, SetEditType] = useState<any | string>('C');
  const token = localStorage.getItem('token');
  const loginuserid = localStorage.getItem('user_id');

  const textRef = useRef(null);
  const [ filterUser, setFilterUser ] = useState<any[]>([]);
  const [ searchText, setSearchText ] = useState('');

  const onClickSticker = (data: any) => {
    setFilterUser([]);

    let editor = (textRef.current  as any ).getEditor();
    var range = editor.getSelection();
    let position = range ? range.index : editor.getLength()-1;

    // Preserve scroll position — see CommentBox.onClickSticker for the
    // full explanation. Without this, Quill's focus + setSelection
    // calls scroll the editor into view and yank the user away from
    // the post they were commenting on.
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    var rte = document.getElementById('my-rich-text-editor'); // Replace with the ID of your Rich Text Editor
    rte?.focus({ preventScroll: true });
    var imageSrc = data;
    editor.insertEmbed(position, 'image', imageSrc);
    editor.setSelection(position + 1, 0);

    window.scrollTo(scrollX, scrollY);
    requestAnimationFrame(() => window.scrollTo(scrollX, scrollY));
  }

  useEffect(() => {
    if (!editbox) {
      return;
    }

    const initialMessage = chat_reply_msg || '';
    SetStickerSelection(initialMessage);
    setValue('chat_reply_msg', initialMessage);
    setFilterUser([]);
  }, [chat_reply_msg, editbox, setValue]);

  useEffect(() => {
    setValue('chat_reply_msg', stickerSelection);
    if (stickerSelection == '' || stickerSelection == '<p><br></p>') {
      setFilterUser([]);
    }
  }, [setValue, stickerSelection]);

  const openSticker = () => {
    SetShowSticker(!showSticker);
  };

  const { LoungeId, url } = useParams();
  const [Notify, setIsNotify] = useState<any | string>();

  const onSubmit = (data: any) => {
    data['chat_reply_msg'] = stickerSelection; 
     /* return false; */
    
     if(type === 'WC' || type === 'WR') {
      data['type'] = type.slice(1);
      stickerSelection != '<p><br></p>' && stickerSelection != ''
      ? dispatch<any>(postLoungeCommentEditWdw(data)).then((res: any) => {
          reset();
          SetStickerSelection('');
          window.location.reload();
          // Notify(toast('Updated Successfully'));
        })
      : alert('Please enter comment');
     }
     else {
      stickerSelection != '<p><br></p>' && stickerSelection != ''
        ? dispatch<any>(postLoungeCommentEdit(data)).then((res: any) => {
            reset();
            SetStickerSelection('');
            window.location.reload();
            // Notify(toast('Updated Successfully'));
          })
        : alert('Please enter comment');
     }
  };

 
  const onChangeFilterUser = (item: any) => {
    const username = String(item?.value ?? '').replace(/^@/, '').trim();
    const normalizedUsername = username.toLowerCase();

    if (normalizedUsername) {
      selectedMentionRef.current = normalizedUsername;
      window.setTimeout(() => {
        if (selectedMentionRef.current === normalizedUsername) {
          selectedMentionRef.current = '';
        }
      }, 1000);
    }

    const nextText = insertCommentMention({
      editor: (textRef.current as any)?.getEditor?.(),
      currentText: stickerSelection,
      searchText,
      username,
    });

    SetStickerSelection(nextText);
    setValue('chat_reply_msg', nextText);
    setSearchText('');
    setFilterUser([]);
  }

  return (
    <>
      {editbox == true && (
        <div>
          <div className='editbox mw-comment-edit-box'>
            {type === 'C' || type === 'WC' ? (
              <h6 style={{ textAlign: 'center', color: 'red' }}>
                Edit
              </h6>
            ) : (
              <h6 style={{ textAlign: 'center', color: 'red' }}>
                Reply
              </h6>
            )}           

            <form
              className='space-y-6'
              onSubmit={handleSubmit(onSubmit)}
              method='POST'
            >
              <div className='com-box-main' style={{position: 'relative'}}>

                {filterUser.length > 0 && (
                <div className="tagUserList mw-mention-picker" role="listbox" aria-label="Tag a MouseWait user">
                  {
                    filterUser.map((item, index) => {
                      return (
                        <div className="tagUserItem" key={item?.id ?? item?.value ?? index}>
                          <button
                            type="button"
                            onMouseDown={(event) => event.preventDefault()}
                            onClick={() => onChangeFilterUser(item)}
                            className="button"
                          >
                            <div>
                              <img
                                style={{ verticalAlign: 'middle' }}
                                src={
                                  GET_BASE_URL_IMAGE +
                                  '/disneyland/images/thumbs/' +
                                  item['image']
                                }
                                className='com-imggg'
                                alt=""
                              />
                            </div>
                            
                            <div>
                              @{item['value']}
                            </div>
                          </button>
                        </div>
                      )
                    })
                  }
                  </div>
                )}

                <div className='com-box d-flex'>
                  <ReactQuill
                    theme='snow'
                    className='form-control'
                    modules={modules}
                    onChange={SetStickerSelection}
                    value={stickerSelection}
                    placeholder='Add your magic...'
                    ref={textRef}
                  />

                  <input
                    type='hidden'
                    readOnly={true}
                    {...register('chat_id')}
                    defaultValue={chatId}
                  />
                  <input
                    type='hidden'
                    readOnly={true}
                    {...register('chat_reply_id')}
                    defaultValue={chat_reply_id}
                  />
                  <input
                    type='hidden'
                    readOnly={true}
                    {...register('type')}
                    defaultValue={type}
                  />
                  <input
                    type='hidden'
                    readOnly={true}
                    {...register('id')}
                    defaultValue={id}
                  />
                  <div className='icon-ic d-flex'>
                    <div
                      className='icon-ic0'
                      onClick={handleSubmit(onSubmit)}
                    ></div>
                    <div className='icon-ic1' onClick={openSticker}></div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          {showSticker == true && (
            <div className='mw-sticker-popover-wrap'>
              <button
                type='button'
                className='mw-sticker-popover-close'
                aria-label='Close sticker picker'
                onClick={() => SetShowSticker(false)}
              >
                ×
              </button>
              <StickerTabs
                tabData={stickerData}
                onClickSticker={onClickSticker}
                onStickerInserted={() => SetShowSticker(false)}
              />
            </div>
          )}{' '}
        </div>
      )}
    </>
  );
};
